import { registerLegacySalvoLiteComponent } from '@eastsideco/salvo-ts';

class ReadMore {
    constructor(theme, elem) {
        this._theme = theme;
        this._name = this.constructor.name;
        this._elem = elem;
        this._content = elem.querySelector('[data-read-more-content]');
        this._cta = elem.querySelector('[data-read-more-cta]'); 
        this._excerpt = elem.querySelector('[data-read-more-excerpt]');   
    }

    onInit() {
        if (this._excerpt) {
            this.handleExcerpt()
        } else {
            this._cta.addEventListener('click', () => {
                this._content.classList.toggle('open')
                this.toggleCtaText()
            })
        }
    }

    handleExcerpt () {
        this._content.classList.add('open')
        this._content.classList.add('visually-hidden')

        this._cta.addEventListener('click', () => {
            this._content.classList.toggle('visually-hidden')
            this._excerpt.classList.toggle('visually-hidden')
            this.toggleCtaText()
        })
    }

    toggleCtaText () {
        if (this._cta.innerHTML === 'Read More') {
            this._cta.innerHTML = 'Read Less';
        } else {
            this._cta.innerHTML = 'Read More';
        }
    }
}

export default registerLegacySalvoLiteComponent({
    component: ReadMore,
    selector: '[data-read-more]', // Required
});
